import React from "react";
import styled from "styled-components";

const Container = styled.div`
	font-family: Roboto;
	display: flex;
	align-items: center;
	background-color: ${(props) => (props.checked ? "#004ECC" : "#e4e5e7")};
	padding: 12px 16px;
	border-radius: 10px;
	margin-bottom: 1rem;
	cursor: pointer;

	.rr-image-check-text {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
		color: ${(props) => (props.checked ? "#ffffff" : "#18191b")};
		height: 100%;
	}

	.rr-image-check-img {
		width: 50%;
		min-width: 90px;
		height: 90px;
		border-radius: 10px;
		margin-bottom: 10px;
		// margin-top: -16px;
	}

	.rr-image-check-label-text {
		font-size: 16px;
		font-weight: 500;
	}
`;

function ImageCheck({ src, checked, onClick, label, ...props }) {
	return (
		<Container {...props} checked={checked} onClick={onClick}>
			<div className="rr-image-check-text">
				<img className="rr-image-check-img" src={src} />
				{/* src={`https://insurstg.wpengine.com${src}`} */}
				<span className="rr-image-check-label-text">{label}</span>
			</div>
		</Container>
	);
}

export default ImageCheck;
